import type { FaireThemeEntity } from "../../entity_types/theme";

export const whimsical_home_accents: FaireThemeEntity = {
  token: "whimsical-home-accents",
  type: "theme",
  name: "Whimsical Home Accents",
  description: "Delight your customers with unexpected, conversation-starting gifts. From quirky pet bowls to artistic matches, these items add a playful spark to any shelf.",
  teaser: "As a gift shop that stocks puzzles and decorative figurines, your business thrives on unique, giftable items that catch a shopper's eye in a brick-and-mortar setting.",
  detail: "Your current cart contains a tire-shaped dog bowl, a peacock display plush toy, and doghouse-shaped matches, demonstrating a clear interest in functional items with a fun, artistic twist.",
  bgColor: "#D4E6F1",
  tileBgColor: "#3b6b3b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_caryztwwjp",
    "p_kaau553gn5",
    "p_eb29ktggtc",
    "p_2urj9tzhvw",
    "p_a7d91nlx8a",
    "p_b7vsk67ywt",
    "p_d7v3b8tdmz",
    "p_m84mzvyxma",
    "p_yh3tmuwzdq",
    "p_2nvdjc8rf6",
    "p_kxkswbdx7b",
    "p_9har3w5xpj",
    "p_6gw5km92dw",
    "p_cbj63hk6dy",
    "p_vug9zskfbp",
    "p_gxxb9ngfzj",
    "p_n33msrc88v",
    "p_pj6ztfyg3f",
    "p_bvou1u08qk",
    "p_1ws7ty688t",
    "p_avmdpaxq9u",
    "p_3m4yztk7bq",
    "p_s8423zd4wa",
    "p_hcv8jf7dm8",
    "p_qqs8tj47at",
    "p_qyq7725v2n",
    "p_pjuxsgz4a5",
    "p_m6nym54jsw",
    "p_upm9ppsr82",
    "p_bm7tync8ep",
    "p_a8hv3ezy6k",
    "p_9vnqqwspwq",
    "p_ff5z59dch8",
    "p_p9zg8y8uf9",
    "p_fwcdybgnrs",
    "p_gp27qf7p62",
    "p_javetey6r3",
    "p_p2tym9jj3s",
    "p_9r26u7ep2w",
    "p_2yjk6faajr",
    "p_eryb7tcze3",
    "p_m3yfkxwptn",
    "p_qnw35jeytc",
    "p_n6sb39sh5y",
    "p_8g2mbmh5mg",
    "p_mr7mjjq4xp",
    "p_whajr4wyk6",
    "p_d2fh328a6c",
    "p_sh3n679vmv",
    "p_r5s3xfph6p",
    "p_vxvz83rgb6",
    "p_74azx6nxsc",
    "p_68xz54736c",
    "p_j9e4j8y3wp",
    "p_cyjxeahx2g",
    "p_x3vc5r4ena",
    "p_8tytmakn33",
    "p_7dcqpf7jgh",
    "p_ymq2dk6syf",
    "p_ns4qq4zqqm",
    "p_aaf4gjn32d",
    "p_dk1ph1c8h1",
    "p_fp6c5tfe2x",
    "p_ue8vjmyn7j",
    "p_fzpwk2jqgc",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
